__turbopack_context__.v({
  "accordionSlideOverwrite": "termSheetLayout-module-scss-module__FkdX6q__accordionSlideOverwrite",
  "drawerShareButton": "termSheetLayout-module-scss-module__FkdX6q__drawerShareButton",
  "fadeIn": "termSheetLayout-module-scss-module__FkdX6q__fadeIn",
  "fadeOut": "termSheetLayout-module-scss-module__FkdX6q__fadeOut",
  "footer": "termSheetLayout-module-scss-module__FkdX6q__footer",
  "footerSpacer": "termSheetLayout-module-scss-module__FkdX6q__footerSpacer",
  "left": "termSheetLayout-module-scss-module__FkdX6q__left",
  "leftContent": "termSheetLayout-module-scss-module__FkdX6q__leftContent",
  "leftDrawer": "termSheetLayout-module-scss-module__FkdX6q__leftDrawer",
  "nextButton": "termSheetLayout-module-scss-module__FkdX6q__nextButton",
  "previewContainerFull": "termSheetLayout-module-scss-module__FkdX6q__previewContainerFull",
  "right": "termSheetLayout-module-scss-module__FkdX6q__right",
  "rightDrawer": "termSheetLayout-module-scss-module__FkdX6q__rightDrawer",
  "scaleIn": "termSheetLayout-module-scss-module__FkdX6q__scaleIn",
  "scaleOut": "termSheetLayout-module-scss-module__FkdX6q__scaleOut",
  "scrollContainer": "termSheetLayout-module-scss-module__FkdX6q__scrollContainer",
  "termSheetLayout": "termSheetLayout-module-scss-module__FkdX6q__termSheetLayout",
  "zoomIn": "termSheetLayout-module-scss-module__FkdX6q__zoomIn",
  "zoomOut": "termSheetLayout-module-scss-module__FkdX6q__zoomOut",
});
